import React from 'react';
import { useIntl } from 'react-intl';
import { Option, Select } from 'carbon-react/lib/components/select';

import { RepeatingPattern } from '../../../types';
import styles from '../repeating-method.scss';

interface RepeatPatternProps {
  disabled?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  value: string;
}

export const RepeatPattern = ({ disabled, onChange, value }: RepeatPatternProps) => {
  const intl = useIntl();

  return (
    <div className={styles.carbonActionItem}>
      <Select
        autoComplete="off"
        disabled={disabled}
        onChange={onChange}
        value={value}
        label={intl.formatMessage({ id: 'common.repeat', defaultMessage: 'Repeat' })}
        size="large"
      >
        <Option
          value={RepeatingPattern.daily}
          text={intl.formatMessage({ id: 'common.repeat_daily', defaultMessage: 'Daily' })}
        />
        <Option
          value={RepeatingPattern.weekly}
          text={intl.formatMessage({ id: 'common.repeat_weekly', defaultMessage: 'Weekly' })}
        />
        <Option
          value={RepeatingPattern.monthly}
          text={intl.formatMessage({ id: 'common.repeat_monthly', defaultMessage: 'Monthly' })}
        />
        <Option
          value={RepeatingPattern.quarterly}
          text={intl.formatMessage({ id: 'common.repeat_quarterly', defaultMessage: 'Quarterly' })}
        />
        <Option
          value={RepeatingPattern.annually}
          text={intl.formatMessage({ id: 'common.repeat_annually', defaultMessage: 'Annually' })}
        />
      </Select>
    </div>
  );
};
